<script setup lang="ts">
import { onUnmounted, onMounted, ref, computed } from 'vue'
import Dashboard from './Dashboard.vue'
import DataTable from './datatable/DataTable.vue'
import SplitDataTable from './datatable/SplitDataTable.vue'
import TabbedDataTable from './datatable/TabbedDataTable.vue'
import Tasks from './Tasks.vue'
import RolesRights from './RolesRights.vue'
import GefahrstoffDetailSheet from './GefahrstoffDetailSheet.vue'
import GefahrstoffBatchUpdate from './GefahrstoffBatchUpdate.vue'
import LogsView from './Logs.vue'
import GefahrstoffForm from './GefahrstoffForm.vue'
import axios from "axios"
import AppSidebar from '@/components/AppSidebar.vue'
import { storeToRefs } from "pinia"
import { useEntityStore } from "@/stores/useEntityStore"
import EditorPanel from './datatable/EditorPanel.vue'
import SingleSelect from './datatable/SingleSelect.vue'
import RgStandardTexts from './RgStandardTexts.vue'
import {
  SidebarInset,
  SidebarProvider,
} from '@/components/ui/sidebar'
import { useViewStore } from '@/stores/viewStore'
import { PieChart,UsersRound,
MapPin,
Import,
BookOpenText,
Pyramid,
CircleUserRound,
SendHorizontal,
FileSpreadsheet,
Quote,
Workflow,
MessageCircle,
MessageCirclePlus,
Loader2,
Copy,
RefreshCw
} from "lucide-vue-next";
import RechtsgrundlagenLogo from '@/components/images/rechtsgrundlagen.svg'
import PflichtenLogo from '@/components/images/pflichten.svg'

import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { todayISO, applyMatrixChange, sendNotification, generateExcel, get_data_attr, getRgId, getRgTitle, getRgPflichtenLabel, getRgStandardTextsLabel } from '@/utils/globals'
import rkIconUrl from '@/components/images/rk.svg?url'
import { useToast, Toaster } from "@/components/ui/toast"
   
import { useI18n } from 'vue-i18n';
import StandortSelect from './StandortSelect.vue'

const { t } = useI18n();

const { toast } = useToast()

const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
if (token) axios.defaults.headers.common["X-CSRF-Token"] = token

const datarechtsgrundlagen = ref([])
const datakunden = ref([])
const datafunctions = ref([])
const datausers = ref([])
const isLoading = ref(true)

const customerInfo = get_data_attr("customer");
const userInfo = get_data_attr("user");
const viewStore = useViewStore();
viewStore.hydrateAssignmentScopeMask(userInfo?.assignment_scope_mask);
const RG_CUSTOMER_ASSIGNMENT_STATE_KEY = 'rechtsgrundlagen-customer-assignment'
const PF_CUSTOMER_ASSIGNMENT_STATE_KEY = 'pflichten-customer-assignment'

// Centralize edit-enable logic for all Registry DataTables.
// Note: DataTable still additionally gates the pencil button by userInfo flags.
const enableEditRegistryTables = computed(() => !!(userInfo?.is_assigner || userInfo?.is_hoeppner))

const selectedRgId = ref(null)

const rgTable = ref<InstanceType<typeof TabbedDataTable> | null>(null);
const splitRgRef = ref<InstanceType<typeof SplitDataTable>>(null);
const splitPfRef = ref<InstanceType<typeof SplitDataTable>>(null);
const splitSubPfRef = ref<InstanceType<typeof SplitDataTable>>(null);
const rgSubTab = ref(null)
const rgFullRow = ref(null)
const splitTaskAssignment = ref(false)
const duplicateCustomerOpen = ref(false)
const duplicateCustomerSource = ref<any>(null)
const duplicateCustomerName = ref("")
const duplicateCustomerStatus = ref("idle")
const duplicateCustomerMessage = ref("")
const duplicateCustomerJobId = ref<number | null>(null)
const duplicateCustomerTargetId = ref<number | null>(null)
let duplicateCustomerPoll: number | null = null
const normifySyncDialogOpen = ref(false)
const normifySyncRow = ref<any>(null)
const normifySyncStatus = ref<"idle" | "running">("idle")
const normifyDebugDialogOpen = ref(false)
const normifyDebugDiff = ref<any>(null)
const normifyDebugJsonOpen = ref(false)

const props = defineProps({
  specsInfo: { type: Object },
});

const emit = defineEmits<{
  (e: 'reset'): void;
}>();


// Create a computed property for actionView that syncs with viewStore
const actionView = computed({
  get: () => viewStore.actionView,
  set: (value) => {
    viewStore.actionView = value;
  }
});


async function getDataUrl(url) {
  try {
    const response = await fetch(url);
    const data = await response.json();
    console.log('Received data!', data);
    return data;
  } catch (error) {
    console.error('Error fetching data!', error);
    return null;
  }
}

async function getData(category, all=false): Promise<Project[]> {
  return getDataUrl('/' + category + '.json' + (all ? "?per_page=10000" : ""));
}


async function reload() {
	console.log("reload")
	if (viewStore.actionView == null) {
		viewStore.actionView = 'registry.dashboard';		
	}
	datarechtsgrundlagen.value = await getData('rechtsgrundlagen')
	if (customerInfo.is_hoeppner) {
	  datakunden.value = await getData('kunde', true)
	} else {
	  datafunctions.value = await getData('functions', true)
      datausers.value = await getData('users', true)
	}
	
	console.log("datafunctions.value=" + JSON.stringify(datafunctions.value.map(f => [f.id, f.functionname])))
	//colsbooking.filter(c => c.key === "user_id")[0].options = datausers.value.map(u => ({id: u.id, label: u.name}));
	//colsbooking.filter(c => c.key === "project_id")[0].options = dataprojects.value.map(p => ({id: p.id, label: p.name}));
	//colsuser.filter(c => c.key === "role_id")[0].options = dataroles.value.map(r => ({id: r.id, label: r.name}));
	isLoading.value = false	
}
onMounted(() => reload());

function setSelectedRgId(rgId) {
	selectedRgId.value = rgId;
}


async function sendpasswd(row) {
  if (!window.confirm('Möchten Sie wirklich dem User ' + row["email"] + ' einen Einrichtungslink senden?')) {
	return;
  }
  try {
	const response = await axios.post(`/users/sendpwd/${row.id}`)
    toast({ title: "Einrichtungslink", description: response.data?.message || "gesendet" })
  } catch (error) {
	const message =
	  error.response?.data?.message || // if your API returns JSON with "message"
	  error.response?.data?.error || // if your API returns JSON with "message"
	  error.response?.statusText ||   // fallback to status text
	  "Einrichtungslink nicht gesendet."
	toast({ title: "Einrichtungslink nicht gesendet", description: message, variant: "destructive" })
  }
}

async function loginAsUser(row) {
  if (!window.confirm('Als Nutzer ' + row["email"] + ' anmelden?')) {
	return;
  }
  try {
	const response = await axios.post(`/users/${row.id}/impersonate`)
	window.location.href = response.data?.redirect_url || '/'
  } catch (error) {
	const message =
	  error.response?.data?.message ||
	  error.response?.data?.error ||
	  error.response?.statusText ||
	  "Anmeldung als Nutzer fehlgeschlagen."
	toast({ title: "Anmeldung als Nutzer fehlgeschlagen", description: message, variant: "destructive" })
  }
}

const isDownloading = ref(false)

async function generateexcel(row, is_quentic=false) {
  generateExcel(axios, `/excel${is_quentic ? 'quentic' : ''}/${row.id}`, toast, isDownloading)
}

async function do_workflow(row, clear=false) {
  if (!window.confirm('Möchten Sie wirklich den Workflow des Kunden ' + row["Kunde"] + ` ${clear ? ' zurück setzen?' : ' aktualisieren?'}`)) {
	return;
  }
  try {
	await axios.post(`/updateworkflows/${row.id + (clear ? '?clearworkflow=1' : '')}`)	
	toast({ title: "Workflow", description: clear ? "zurück gesetzt" : "aktualisiert" })
  } catch (error) {
	const message =
	  error.response?.data?.message || // if your API returns JSON with "message"
	  error.response?.data?.error || // if your API returns JSON with "message"
	  error.response?.statusText ||   // fallback to status text
	  "Workflow aktualisierung gescheitert."
	toast({ title: "Workflow aktualisierung gescheitert", description: message, variant: "destructive" })
  }
}

function canDuplicateMuster(row) {
  return Boolean(userInfo?.can_impersonate_users && Number(row?.id || row?.id_kunde) === 2000003)
}

function openDuplicateCustomer(row) {
  clearDuplicateCustomerPoll()
  duplicateCustomerSource.value = row
  duplicateCustomerName.value = ""
  duplicateCustomerStatus.value = "idle"
  duplicateCustomerMessage.value = ""
  duplicateCustomerJobId.value = null
  duplicateCustomerTargetId.value = null
  duplicateCustomerOpen.value = true
}

async function submitDuplicateCustomer() {
  const name = duplicateCustomerName.value.trim()
  if (!duplicateCustomerSource.value || !name) {
    duplicateCustomerMessage.value = t('view.customer_duplicate_name_required')
    return
  }

  try {
    duplicateCustomerStatus.value = "queued"
    duplicateCustomerMessage.value = t('view.customer_duplicate_started')
    const response = await axios.post(`/kunde/${duplicateCustomerSource.value.id}/duplicate`, { Kunde: name })
    duplicateCustomerJobId.value = response.data.job_id
    duplicateCustomerTargetId.value = response.data.target_customer_id
    duplicateCustomerStatus.value = response.data.status || "queued"
    duplicateCustomerMessage.value = response.data.message || t('view.customer_duplicate_started')
    startDuplicateCustomerPolling()
    await pollDuplicateCustomerJob()
  } catch (error) {
    const message =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.response?.statusText ||
      t('view.customer_duplicate_failed')
    duplicateCustomerStatus.value = "failed"
    duplicateCustomerMessage.value = message
    toast({ title: t('view.customer_duplicate_failed'), description: message, variant: "destructive" })
  }
}

function startDuplicateCustomerPolling() {
  clearDuplicateCustomerPoll()
  duplicateCustomerPoll = window.setInterval(() => {
    pollDuplicateCustomerJob()
  }, 3000)
}

async function pollDuplicateCustomerJob() {
  if (!duplicateCustomerJobId.value) return

  try {
    const response = await axios.get(`/kunde/duplication_jobs/${duplicateCustomerJobId.value}`)
    duplicateCustomerStatus.value = response.data.status
    duplicateCustomerMessage.value = response.data.message || ""
    duplicateCustomerTargetId.value = response.data.target_customer_id

    if (response.data.status === "succeeded") {
      clearDuplicateCustomerPoll()
      datakunden.value = await getData('kunde', true)
      toast({
        title: t('view.customer_duplicate_done'),
        description: response.data.message || t('view.customer_duplicate_done')
      })
    } else if (response.data.status === "failed") {
      clearDuplicateCustomerPoll()
      toast({
        title: t('view.customer_duplicate_failed'),
        description: response.data.message || t('view.customer_duplicate_failed'),
        variant: "destructive"
      })
    }
  } catch (error) {
    clearDuplicateCustomerPoll()
    const message =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.response?.statusText ||
      t('view.customer_duplicate_failed')
    duplicateCustomerStatus.value = "failed"
    duplicateCustomerMessage.value = message
  }
}

function clearDuplicateCustomerPoll() {
  if (duplicateCustomerPoll !== null) {
    window.clearInterval(duplicateCustomerPoll)
    duplicateCustomerPoll = null
  }
}

onUnmounted(() => clearDuplicateCustomerPoll())

// Computed properties for assignment labels (reactive to locale changes)
const cust_assignment_text = computed(() => t('view.customer_assignment'));
const function_assignment_text = computed(() => t('view.function_assignment'));

const canEditFunctionAssignment = computed(() => {
  return Boolean(userInfo?.is_hoeppner || userInfo?.is_assigner)
})

function getAssignmentLabel(customerInfo) {
	return customerInfo.is_hoeppner ? cust_assignment_text.value : function_assignment_text.value;
}

function showHideText(customerInfo, show) {
	const actionText = show ? t('view.hide') : t('view.edit');
	return `${actionText} ${getAssignmentLabel(customerInfo)}`;
}


function status_options(type) {
	const colors_status = get_data_attr("colors_status_" + type);
	return get_data_attr("choice_status_" + type).map(status => ({id: status[1], label: status[0], bgcolor: colors_status[status[1]]}));
}

const ownAssignmentColumnKeys = computed(() => {
  if (customerInfo.is_hoeppner) return []
  const fids = userInfo.function_ids || []
  return fids.map((id: number) => "assignment." + id)
})

function assignmentTableKey(type: string, base: string) {
  return `${base}-${type}-${viewStore.assignmentScopeMask ?? 'unset'}-${viewStore.refreshKey}`
}

function assignmentColumnStateKey(type: string, base: string) {
  if (customerInfo.is_hoeppner) return base
  return viewStore.assignmentScopeMode(type) === 'own' ? `${base}-own` : base
}

function getAssignmentColumns(customerInfo, type) {
  if (customerInfo.is_hoeppner) {
	let kundecols =  datakunden.value.filter(k => k.id_kunde !== 10).map(k => ({key: "assignment." + k.id_kunde, kid: k.id_kunde, standorts: k.standorts, label: k.Kunde + "(" + k.id_kunde +  ")", togglefilter: true, type: 'boolean', show: true, write: true})).sort((a, b) => a.label.localeCompare(b.label))
	console.log("kundecols=" + JSON.stringify(kundecols))
	return kundecols
  } else {
	if (type === 'pflichten') {
      console.log('[getAssignmentColumns BEFORE map]', {
        endpoint: 'pflichten-sub-assignment',
        datafunctions: datafunctions.value.map(f => ({ id: f.id, functionname: f.functionname }))
      })
    }
	const ownSet = new Set(ownAssignmentColumnKeys.value)
	const defaultShow = ownSet.size === 0
	const isAssignee = userInfo.is_assignee && ownSet.size > 0
	const scopeOwnOnly = viewStore.isAssignmentOwn(type) === true && ownSet.size > 0
	const scopeShowAll = viewStore.isAssignmentOwn(type) === false
	const cols = datafunctions.value.map(f => {
	  const key = "assignment." + f.id
	  const baseCanWrite = !isAssignee || ownSet.has(key)
	  const canWrite = scopeOwnOnly ? ownSet.has(key) : baseCanWrite
	  const canShow = scopeShowAll || (scopeOwnOnly ? ownSet.has(key) : (defaultShow || ownSet.has(key)))
	  return {key, label: f.functionname + "(" + f.id + ")", type: 'select', togglefilter: true, show: canShow, write: canWrite, options:status_options(type), width: '160px'}
	}).sort((a, b) => a.label.localeCompare(b.label))
	console.log("[getAssignmentColumns SNAPSHOT]", JSON.parse(JSON.stringify(cols)))
	console.log("[getAssignmentColumns]", { type, cols })

	return cols	
  }
}

function getAssignmentColumnsNotifications(type) {
	console.log("getAssignmentColumnsNotifications=" + JSON.stringify(datafunctions.value.map(f => ({id: f.id, label: f.functionname}))))
	return [{key: 'id'    , label: 'Funktion', type: 'select', show: true, write: false, options: datafunctions.value.map(f => ({id: f.id, label: f.functionname}))}, 
	        {key: "status", label: "Status"  , type: 'select', show: true, write: true , options: status_options(type), width: '160px'}]
}

function getAssignments(assignments) {
	console.log("getAssignments=" + JSON.stringify(assignments))
    return Object.entries(assignments).map(([k, v]) => ({ id: parseInt(k), status: v }));
}

const rightRgData = ref<any[]>([]);
const rightPfData = ref<any[]>([]);

async function applyNotificationAssignmentChange(change) {
//	change={"id":1300314,"path":"assignment.157","value":0}
	change["path"] = "assignment." + change.id
	change.id = selectedPflichtId.value
	applyMatrixChange(axios, toast, customerInfo, "pflichten", change, true) 
}



const splitterPflichtRef   = ref()
const selectedPflichtId    = ref(null)
const selectedPflicht      = ref(null)
const selectedNotification = ref(null)
const updatedNotification  = ref(0)
const entityStore = useEntityStore()
const { currentItem, showEditor, editorSaving } = storeToRefs(entityStore)


function setSelectedPflicht(row) {
	selectedPflichtId.value = row.id
	selectedPflicht.value = row
	
	console.log("setSelectedPflicht=" + JSON.stringify(row))

	if (!row.notification) {
	  row.notification = {}
	}
	
	if (!row.notification.id) {
		row.notification["title"] = row["Kurzbeschreibung / Überschrift"]
		row.notification["duedate"] = todayISO()
		row.notification["period"] = 0
		row.notification["is_notification"] = 1
		row.notification["originator_id"] = userInfo.id
		row.notification["pfm_id"] = row.pfm_id
		console.log("specsinfo tasks=" + JSON.stringify(props.specsInfo['tasks']))
	} 
	entityStore.openEditor('tasks', row.notification)
	
	//selectedNotification.value = 
}

function closeNotification() {
  console.log("closeNotification")
  //selectedPflicht.value = null;
  //selectedPflichtId.value = null;
  entityStore.closeEditor('tasks')
}

function saveNotification() {
  console.log("tasks")
  entityStore.saveEditor('tasks', 'tasks', () => {})
  //selectedPflicht.value = null;
  //selectedPflichtId.value = null;
  updatedNotification.value++	
}

const choice_notification = get_data_attr("choice_notification").map(status => ({id: status[1], label: status[0]}));

const is_notification = ref(-1)

const rgDataTable = ref<any>(null)
const pfDataTable = ref<any>(null)

function assignmentStandortValue(rtype: string, customerId: string | number) {
  return viewStore.getAssignmentStandort(rtype, customerId)
}

function currentLegalTableParams(rtype: string) {
  const tableRef = rtype === 'rechtsgrundlagen' ? rgDataTable.value : pfDataTable.value
  const params = tableRef?.currentQueryParams?.() || {}
  delete params.reset_filter
  delete params.reset_filter_button
  return params
}

async function filterNotificationRg(val) {
  rgDataTable.value?.onColumnFilterChange("is_notification", val)
}

async function filterNotificationPf(val) {
  pfDataTable.value?.onColumnFilterChange("is_notification", val)
}

async function applyAssignmentMatrixChange(rtype: string, change: any) {
  const saved = await applyMatrixChange(axios, toast, customerInfo, rtype, change, true)
  if (!saved) return

  const tableRef = rtype === 'rechtsgrundlagen' ? rgDataTable.value : pfDataTable.value
  await tableRef?.reloadData?.()
}


function swapcol(endpoint, from, to) {
	console.log("swapcol endpoint=" + endpoint + " from=" + from + " to=" + to)
    emit('reset')
} 

function patchVisiblePflichtenStatus(propagated: any) {
  if (!propagated?.hmc_ids?.length) return

  const status = Number(propagated.status)
  const hmcIds = propagated.hmc_ids.map((id: string | number) => Number(id))
  const hmcIdSet = new Set(hmcIds)

  pfDataTable.value?.patchLocalRowsByIds?.(hmcIds, { status })
  rightPfData.value = rightPfData.value.map((row: any) => {
    if (!hmcIdSet.has(Number(row?.id))) return row
    return { ...row, status }
  })
}

function onDataMutated(endpoint: string, responseData: any = null) {
  if (endpoint === 'functions') {
    emit('reset')
  }
  if (endpoint === 'rechtsgrundlagen') {
    patchVisiblePflichtenStatus(responseData?.propagated_pflichtenmatrix)
  }
}

async function openRgStandardTexts(row: any) {
  rgSubTab.value = 2

  // Render the tab immediately (with empty data) and fill it after fetch.
  rgFullRow.value = { ...row, standardtexts: [] }

  // Open the right panel tab (matches existing behavior).
  rgTable.value?.openRowTab(getRgId(row), getRgStandardTextsLabel(row))

  if (!row?.hasStandardtexts) return

  try {
    const rgId = getRgId(row)
    const res = await axios.get(`/rechtsgrundlagen/${rgId}/standardtexts.json`)
    rgFullRow.value.standardtexts = res.data
  } catch (error: any) {
    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.response?.statusText ||
      "Standard Texts konnten nicht geladen werden."

    rgFullRow.value.standardtexts = []
    toast({ title: "Standard Texts", description: message, variant: "destructive" })
  }
}

function requestRechtsgrundlageNormifySync(row: any) {
  normifySyncRow.value = row
  normifySyncStatus.value = "idle"
  normifySyncDialogOpen.value = true
}

async function syncSelectedRechtsgrundlageFromNormify(overwrite: boolean) {
  if (!normifySyncRow.value) return

  await syncRechtsgrundlageFromNormify(normifySyncRow.value, overwrite)
}

async function syncRechtsgrundlageFromNormify(row: any, overwrite: boolean) {
  const rgId = getRgId(row)
  const rgTitle = getRgTitle(row)
  normifySyncStatus.value = "running"

  try {
    const response = await axios.post(`/rechtsgrundlagen/${rgId}/sync_normify.json`, { overwrite, debug_diff: true })
    toast({
      title: "Normify",
      description: response.data?.message || `${rgTitle} aktualisiert.`
    })
    if (response.data?.debugDiff) {
      normifyDebugDiff.value = {
        ...response.data.debugDiff,
        rgTitle,
        standardtexts: response.data.standardtexts,
        pflichten: response.data.pflichten
      }
      normifyDebugJsonOpen.value = false
      normifyDebugDialogOpen.value = true
    }
    await rgDataTable.value?.reloadData?.()
    emit('reset')
    normifySyncDialogOpen.value = false
    normifySyncRow.value = null
  } catch (error: any) {
    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.response?.statusText ||
      "Normify Aktualisierung fehlgeschlagen."
    toast({ title: "Normify Aktualisierung fehlgeschlagen", description: message, variant: "destructive" })
  } finally {
    normifySyncStatus.value = "idle"
  }
}

function normifyDebugRows() {
  return Array.isArray(normifyDebugDiff.value?.rows) ? normifyDebugDiff.value.rows : []
}

function formatNormifyDebugValue(value: any) {
  if (value === null || value === undefined || value === "") return "-"
  if (typeof value === "boolean") return value ? "true" : "false"
  if (typeof value === "object") return JSON.stringify(value)
  return String(value)
}

function formatNormifyDebugStats(stats: any) {
  const data = stats || {}
  return `${data.created || 0}/${data.updated || 0}/${data.skipped || 0}/${data.failed || 0}`
}

function formatNormifyApiJson() {
  return JSON.stringify({
    payload: normifyDebugDiff.value?.normifyApiPayload || {},
    result: normifyDebugDiff.value?.normifyApiResult || {}
  }, null, 2)
}

async function handleCustomerStandort(standort_id, customer_id, rtype) {
  console.log("customer_id=" + customer_id + " standort_id=" + standort_id)
   try {
    const response = await axios.get(`/${rtype}.json`, {
      params: {
        ...currentLegalTableParams(rtype),
        kunde_id: customer_id,
        kunde_standort_id: standort_id,
      },
    })
	if (rtype === "rechtsgrundlagen") {
      rightRgData.value = response.data
	} else {
      rightPfData.value = response.data
	}
    viewStore.setAssignmentStandort(rtype, customer_id, standort_id)
  } catch (error) {
		const message =
	  error.response?.data?.message || // if your API returns JSON with "message"
	  error.response?.data?.error || // if your API returns JSON with "message"
	  error.response?.statusText ||   // fallback to status text
	  "Standort nicht gesetzt."
	toast({ title: "Standort nicht gesetzt", description: message, variant: "destructive" })	
  }
}

console.log("tasks specsinfo=" + JSON.stringify(props.specsInfo['tasks'].map(s => s.key)))
</script>

<template>
  <SidebarProvider>
    <div
      v-if="isDownloading"
      class="fixed inset-0 z-[10050] flex items-center justify-center bg-black/50"
      role="status"
      aria-live="polite"
    >
      <div class="flex items-center gap-3 rounded-md bg-white px-6 py-4 text-gray-900 shadow-lg">
        <Loader2 class="h-6 w-6 animate-spin text-[#80BA27]" />
        <span class="text-sm font-medium">Excel wird generiert...</span>
      </div>
    </div>

    <AppSidebar :actionView="actionView" @updateView="actionView = $event"/>
    <SidebarInset class="w-screen h-screen" style="overflow: auto">	  
		<div style="margin-left: unset; height: 100%; overflow-y: scroll; max-width: unset" :class="['container']">
		  <Dashboard v-if="viewStore.actionView === 'registry.dashboard'  && !isLoading" :icon="PieChart" :specsInfo="props.specsInfo"/>
		  <TabbedDataTable :key="viewStore.refreshKey" ref="rgTable" v-if="viewStore.actionView === 'registry.rechtsgrundlagen'  && !isLoading"
		             label="view.rechtsgrundlagen" :logo="rkIconUrl" endpoint="rechtsgrundlagen"
					 :columns="specsInfo['rechtsgrundlagen']">
			<template #maincontent>
				<SplitDataTable ref="splitRgRef" :stateKey="RG_CUSTOMER_ASSIGNMENT_STATE_KEY">
					<template #left>
				        <DataTable ref="rgDataTable" label="view.rechtsgrundlagen" 
						           labelSingular="view.rechtsgrundlage"
						           :logo="rkIconUrl"
								   endpoint="rechtsgrundlagen"
								   filterStateKey="rechtsgrundlagen-table-filters"
								   assignmentScopeArea="rechtsgrundlagen"
								   :resetSessionFilterKey="viewStore.legalNavResetKey"
								   v-bind="{ ...(!customerInfo.is_hoeppner ? { saveendpoint: 'rechtsgrundlagenmatrix' } : {}) }"
						           :columns="specsInfo['rechtsgrundlagen']"
								   :editorExcludeKeys="['extra10']"
								   :enableAdd="customerInfo.is_hoeppner"
								   :enableEdit="enableEditRegistryTables"
								   :enableDelete="customerInfo.is_hoeppner"
								   :headerFontSize="14"
								   :actionColumnWidth="220"
								   @swapcol="swapcol"
						           @page-loaded="rightRgData = $event">
					        <template #logo><RechtsgrundlagenLogo  class="w-8 h-8"/></template>
							<template #extraglobalactions>
								 
								<button
								  v-if="canEditFunctionAssignment"
								  @click="splitRgRef?.toggleRight(false)"
								  class="greenbutton text-white rounded w-60 h-9"
								>
								  {{ showHideText(customerInfo, splitRgRef?.showRight) }}
								</button>
							</template>
					        <template #extraactions="{row}">
						        <Button
								        v-if="userInfo?.can_impersonate_users"
								        :title="t('view.btn_rg_normify_update', {rg: getRgTitle(row)})"
								        size="sm"
								        variant="outline"
								        @click="requestRechtsgrundlageNormifySync(row)"
							        >
							          <RefreshCw />
						        </Button>
						        <Button :disabled="!row.hasStandardtexts"
										:class="[row.hasStandardtexts ? 'text-green-600' : 'text-black-600', 'hover:bg-blue-50' ]"

								        :title="t('view.btn_rg_standardtexts', {rg: getRgTitle(row)})" size="sm" variant="outline" @click="openRgStandardTexts(row)">
							          <BookOpenText />
						        </Button>
						        <Button
								        v-if="Number(customerInfo.only_rg) !== 1"
								        :title="t('view.btn_rg_pflichten', {rg: getRgTitle(row)})"
								        size="sm"
								        variant="outline"
								        @click="rgSubTab = 1; rgTable?.openRowTab(getRgId(row), getRgPflichtenLabel(row))"
							        >
							          <PflichtenLogo />
						        </Button>
					        </template>
				        </DataTable>
					</template>
				   <template #right>
				      <DataTable :label="getAssignmentLabel(customerInfo)" :logo="rkIconUrl"
					    :data="rightRgData" :columns="getAssignmentColumns(customerInfo, 'rechtsgrundlagen')"
					    :key="assignmentTableKey('rechtsgrundlagen', RG_CUSTOMER_ASSIGNMENT_STATE_KEY)"
					    :columnStateKey="assignmentColumnStateKey('rechtsgrundlagen', RG_CUSTOMER_ASSIGNMENT_STATE_KEY)"
					    :ownColumnKeys="ownAssignmentColumnKeys"
					     @cell-changed="(change) => applyAssignmentMatrixChange('rechtsgrundlagen', change)"
					     @cell-notified="(change) => sendNotification(axios, toast, customerInfo, 'rechtsgrundlagen', change, true)"
					    :enableAdd="false"
					    :enableEdit="false"
					    :enableDetail="false"
					    :enableDelete="false"
						:enableFilter="false"
						:enableColChange="false"
						:enableCopy="false"
						:enableNotifications="true"
						:alwaysEdit="true"
						:withpaging="false"
						:headerFontSize="12"
						:singleSelectFontsize="12"
						:enableColFilterSide="false"
						:enableColFilterTop="true"
						:hideActionColumn="true"
						:enableAll="true"
						>
				        <template #logo><RechtsgrundlagenLogo  class="w-8 h-8"/></template>
					    <template #colextensions="{col}">
							<div v-if="col.standorts && col.standorts.length > 0" >
							  <StandortSelect
							    :items="col.standorts.map(s => ({value: s.id, label: s.displayname}))"
							    :modelValue="assignmentStandortValue('rechtsgrundlagen', col.kid)"
							    @change="value => handleCustomerStandort(value, col.kid, 'rechtsgrundlagen')"
							  />
							</div>
						</template>
				      </DataTable>
				  </template>
				</SplitDataTable>
			</template>
		    <template #tabbedcontent="{row}">
			   <div v-if="rgSubTab === 2">
				<RgStandardTexts :standardTexts="(rgFullRow?.hasStandardtexts ? (rgFullRow?.standardtexts || []) : [])" />
			   </div>
			   <SplitDataTable v-if="rgSubTab === 1" ref="splitSubPfRef"  :key="viewStore.refreshKey" :stateKey="PF_CUSTOMER_ASSIGNMENT_STATE_KEY">
		  	      <template #left>
				    <DataTable ref="pfDataTable" label="view.pflichten"
					             :logo="rkIconUrl"
				                 endpoint="pflichten"
				                 :endpointpars="{id_rechtsgrundlagen: row}"
								 v-bind="{ ...(!customerInfo.is_hoeppner ? { saveendpoint: 'pflichtenmatrix' } : {}) }"
								 :columns="specsInfo['pflichten']"
								 :editorExcludeKeys="['extra10']"
						         :enableAdd="false"
						         :enableEdit="enableEditRegistryTables"
						         :enableDelete="false"
								 @page-loaded="rightPfData = $event"
						  >
				          <template #logo><PflichtenLogo class="w-8 h-8" /></template>

						  <template #extraglobalactions>
						      <SingleSelect v-if="!customerInfo.is_hoeppner && userInfo.has_notification"
						          :fontSize="props.singleSelectFontsize ? props.singleSelectFontsize : undefined"
						          :options="choice_notification"
						          :preserveOrder="true"
						          :modelValue="is_notification"
						          @update:modelValue="filterNotificationPf"
						      />
			   	              <button v-if="canEditFunctionAssignment" @click="splitSubPfRef?.toggleRight(false)" class="greenbutton text-white rounded w-60 h-9">
			   	                 {{ showHideText(customerInfo, splitSubPfRef?.showRight) }}
			   	              </button>
			              </template>

				    </DataTable>
		          </template>
				  <template #right>
					<DataTable :label="getAssignmentLabel(customerInfo)" :logo="rkIconUrl" :data="rightPfData" :columns="getAssignmentColumns(customerInfo, 'pflichten')"
					  :key="assignmentTableKey('pflichten', PF_CUSTOMER_ASSIGNMENT_STATE_KEY)"
					  :columnStateKey="assignmentColumnStateKey('pflichten', PF_CUSTOMER_ASSIGNMENT_STATE_KEY)"
					  :ownColumnKeys="ownAssignmentColumnKeys"
				      @cell-changed="(change) => applyAssignmentMatrixChange('pflichten', change)"
				      @cell-notified="(change) => sendNotification(axios, toast, customerInfo, 'pflichten', change, true)"
		  	          :enableAdd="false"
		  	          :enableEdit="false"
		  	          :enableDetail="false"
		  	          :enableDelete="false"
			          :enableFilter="false"
				      :enableColChange="false"
		  		      :alwaysEdit="true"
				      :headerFontSize="12"
				      :singleSelectFontsize="12"
				      :enableColFilterSide="false"
				      :enableColFilterTop="true"
				      :enableCopy="false"
				      :enableNotifications="true"
				      :enableAll="true"
				      :hideActionColumn="true"
		  		      :withpaging="false">
		          <template #logo><PflichtenLogo   class="w-8 h-8" /></template>
		        </DataTable>

		          </template>
				</SplitDataTable>
			</template>

		  </TabbedDataTable>
		  
		  <SplitDataTable :key="viewStore.refreshKey" ref="splitPfRef" :stateKey="PF_CUSTOMER_ASSIGNMENT_STATE_KEY" v-if="viewStore.actionView === 'registry.pflichten'  && !isLoading">
		  	<template #left>
				  <DataTable ref="pfDataTable"  
				            label="view.pflichten"
				            :key="updatedNotification"
				            labelSingular="view.pflicht"
				            :logo="rkIconUrl"
				            endpoint="pflichten"
							filterStateKey="pflichten-table-filters"
							assignmentScopeArea="pflichten"
							:resetSessionFilterKey="viewStore.legalNavResetKey"
							v-bind="{ ...(!customerInfo.is_hoeppner ? { saveendpoint: 'pflichtenmatrix' } : {}) }"
							:columns="specsInfo['pflichten']"
							:editorExcludeKeys="['extra10']"
							:enableAdd="customerInfo.is_hoeppner"
							:enableEdit="enableEditRegistryTables"
							:enableDelete="customerInfo.is_hoeppner"
							@swapcol="swapcol"
							@page-loaded="rightPfData = $event">
				    <template #logo><PflichtenLogo   class="w-8 h-8" /></template>
			        <template #extraglobalactions>
						<SingleSelect v-if="!customerInfo.is_hoeppner && userInfo.has_notification"
						  :fontSize="props.singleSelectFontsize ? props.singleSelectFontsize : undefined"
						  :options="choice_notification"
						  :preserveOrder="true"
						  
						  :modelValue="is_notification"
						  @update:modelValue="filterNotificationPf"
						/>
			   	       <button
			   	           v-if="canEditFunctionAssignment"
			   	           @click="splitPfRef?.toggleRight(false)"
			   	           class="greenbutton text-white rounded w-60 h-9"
			           >
			   	       {{ showHideText(customerInfo, splitPfRef?.showRight) }}
			   	      </button>
			        </template>
				    <template v-if="!customerInfo.is_hoeppner && customerInfo.has_notification && userInfo.has_notification" #extraactions={row}>
					  <Button v-if="row.notification?.id" :title="t('view.btn_notification')" size="sm" variant="outline" class="text-black-600 hover:bg-blue-50"
					     @click.stop
					     @click="() => setSelectedPflicht(row)">
					    <MessageCircle />
					  </Button>
				      <Button v-if="!row.notification?.id" :title="t('view.btn_notification_add')" size="sm" variant="outline" class="text-black-600 hover:bg-blue-50"
					     @click.stop
					     @click="() => setSelectedPflicht(row)">
				        <MessageCirclePlus />
				      </Button>
				     </template>
		        </DataTable>

				<EditorPanel v-if="showEditor['tasks']"
							:columns="specsInfo['tasks'].filter(s => s.key !== 'datascope')"
							:label="t('view.edit_notification')"
							:is-saving="!!editorSaving['tasks']"
							:currentItem="currentItem['tasks']"
							endpoint="props.endpoint" 
							@close-editor="closeNotification()"
							@save-editor="saveNotification()">
					<template #extra={item}>
					
					<DataTable :label="t('view.assignment')" :logo="rkIconUrl"
						:data="getAssignments(selectedPflicht.assignment)" :columns="getAssignmentColumnsNotifications('pflichten')"
						@cell-changed="(change) => applyNotificationAssignmentChange(change)"
						:enableAdd="false"
						:enableEdit="false"
						:enableDetail="false"
						:enableDelete="false"
						:enableFilter="false"
						:enableColChange="false"
						:alwaysEdit="true"
						:withpaging="false"
						:headerFontSize="12"
						:singleSelectFontsize="12"
						:enableColFilterSide="false"
						:enableColFilterTop="false"
						:hideActionColumn="true"
					>
					</DataTable>

					</template>
				</EditorPanel>

		  	</template>
		     <template #right>
		        <DataTable :label="getAssignmentLabel(customerInfo)" :logo="rkIconUrl" :data="rightPfData" :columns="getAssignmentColumns(customerInfo, 'pflichten')"
				 :key="assignmentTableKey('pflichten', PF_CUSTOMER_ASSIGNMENT_STATE_KEY)"
				 :columnStateKey="assignmentColumnStateKey('pflichten', PF_CUSTOMER_ASSIGNMENT_STATE_KEY)"
				 :ownColumnKeys="ownAssignmentColumnKeys"
				 @cell-changed="(change) => applyAssignmentMatrixChange('pflichten', change)"
				 @cell-notified="(change) => sendNotification(axios, toast, customerInfo, 'pflichten', change, true)"
		  	    :enableAdd="false"
		  	    :enableEdit="false"
		  	    :enableDetail="false"
		  	    :enableDelete="false"
				:enableFilter="false"
				:enableColChange="false"
		  		:alwaysEdit="true"
				:headerFontSize="12"
				:singleSelectFontsize="12"
				:enableColFilterSide="false"
				:enableColFilterTop="true"
				:enableCopy="false"
				:enableNotifications="true"
				:enableAll="true"
				:hideActionColumn="true"
		  		:withpaging="false">
		          <template #logo><PflichtenLogo   class="w-8 h-8" /></template>
				  <template #colextensions="{col}">
					<div v-if="col.standorts && col.standorts.length > 0" >
					  <StandortSelect
					    :items="col.standorts.map(s => ({value: s.id, label: s.displayname}))"
					    :modelValue="assignmentStandortValue('pflichten', col.kid)"
					    @change="value => handleCustomerStandort(value, col.kid, 'pflichten')"
					  />
					</div>
				 </template>
		        </DataTable>
		    </template>
		  </SplitDataTable>
		  
		  
		  <Tasks  :key="viewStore.refreshKey" v-if="viewStore.actionView === 'registry.tasks' && !isLoading" :specsInfo="specsInfo" @swapcol="swapcol" />

          <DataTable v-if="viewStore.actionView === 'registry.customers' && !isLoading"
					 label="view.customers"
					 labelSingular="view.customer"
					 :logo="rkIconUrl" endpoint="kunde"
					 :columns="specsInfo['kunde']"
					 :enableEdit="enableEditRegistryTables"
					 :actionColumnWidth="360"
		             @swapcol="swapcol">
			<template #logo><CircleUserRound /></template>
		    <template #extraactions="{row}">
		      <Button v-if="canDuplicateMuster(row)" :title="t('view.btn_duplicate_customer')" size="icon" variant="outline" @click="() => openDuplicateCustomer(row)">
		        <Copy class="w-4 h-4" />
		      </Button>
		      <Button :title="t('view.btn_excel')" size="icon" variant="outline" :disabled="isDownloading" @click="() => generateexcel(row)">
		        <FileSpreadsheet class="w-4 h-4" />
		      </Button>
		      <Button :title="t('view.btn_quenticexcel')" size="icon" variant="outline" :disabled="isDownloading" @click="() => generateexcel(row, true)">
		        <Quote class="w-4 h-4" />
		      </Button>
		      <Button :title="t('view.btn_workflow')" size="icon" variant="outline" @click="() => do_workflow(row)" class="text-green-600 hover:bg-blue-50">
		        <Workflow class="w-4 h-4" />
		      </Button>
		      <Button :title="t('view.btn_workflow_clear')" size="icon" variant="outline" @click="() => do_workflow(row, true)" class="text-red-600 hover:bg-blue-50">
		        <Workflow class="w-4 h-4" />
		      </Button>
		    </template>
		  </DataTable>

		  <Dialog v-model:open="normifySyncDialogOpen">
		    <DialogContent class="sm:max-w-2xl">
		      <DialogHeader>
		        <DialogTitle>{{ t('view.rg_normify_update_title') }}</DialogTitle>
		        <DialogDescription>
		          {{ t('view.rg_normify_update_description', { rg: getRgTitle(normifySyncRow || {}) }) }}
		        </DialogDescription>
		      </DialogHeader>
		      <p class="text-sm text-gray-700">
		        {{ t('view.rg_normify_update_choice') }}
		      </p>
		      <DialogFooter class="gap-2 sm:flex-wrap">
		        <Button variant="outline" class="w-full whitespace-normal sm:w-auto sm:whitespace-nowrap" :disabled="normifySyncStatus === 'running'" @click="normifySyncDialogOpen = false">
		          {{ t('view.close') }}
		        </Button>
		        <Button variant="outline" class="w-full whitespace-normal sm:w-auto sm:whitespace-nowrap" :disabled="normifySyncStatus === 'running'" @click="syncSelectedRechtsgrundlageFromNormify(false)">
		          {{ t('view.rg_normify_update_fill_missing') }}
		        </Button>
		        <Button class="greenbutton text-white w-full whitespace-normal sm:w-auto sm:min-w-[10.5rem] sm:whitespace-nowrap" :disabled="normifySyncStatus === 'running'" @click="syncSelectedRechtsgrundlageFromNormify(true)">
		          <Loader2 v-if="normifySyncStatus === 'running'" class="w-4 h-4 mr-2 animate-spin" />
		          {{ t('view.rg_normify_update_overwrite') }}
		        </Button>
		      </DialogFooter>
		    </DialogContent>
		  </Dialog>

		  <Dialog v-model:open="normifyDebugDialogOpen">
		    <DialogContent class="z-[12000] max-h-[92vh] overflow-y-auto sm:max-w-5xl" overlay-class="z-[11990]">
		      <DialogHeader>
		        <DialogTitle>{{ t('view.rg_normify_debug_title') }}</DialogTitle>
		        <DialogDescription>
		          {{ normifyDebugDiff?.rgTitle || normifyDebugDiff?.identifier || normifyDebugDiff?.hmcIntern }}
		        </DialogDescription>
		      </DialogHeader>

		      <div v-if="normifyDebugDiff" class="space-y-4">
		        <div class="grid gap-2 text-sm text-gray-700 sm:grid-cols-3">
		          <div>
		            <span class="font-medium">{{ t('view.rg_normify_debug_hmc') }}:</span>
		            {{ normifyDebugDiff.hmcIntern }}
		          </div>
		          <div>
		            <span class="font-medium">{{ t('view.rg_normify_debug_mode') }}:</span>
		            {{ normifyDebugDiff.overwrite ? t('view.rg_normify_update_overwrite') : t('view.rg_normify_update_fill_missing') }}
		          </div>
		          <div>
		            <span class="font-medium">{{ t('view.rg_normify_debug_changed') }}:</span>
		            {{ normifyDebugDiff.stats?.changed || 0 }}/{{ normifyDebugDiff.stats?.applied || 0 }}
		          </div>
		        </div>

		        <div class="grid gap-2 text-sm text-gray-700 sm:grid-cols-2">
		          <div>
		            <span class="font-medium">{{ t('view.rg_normify_debug_standardtexts') }}:</span>
		            {{ formatNormifyDebugStats(normifyDebugDiff.standardtexts) }}
		          </div>
		          <div>
		            <span class="font-medium">{{ t('view.rg_normify_debug_pflichten') }}:</span>
		            {{ formatNormifyDebugStats(normifyDebugDiff.pflichten) }}
		          </div>
		        </div>

		        <div v-if="normifyDebugRows().length" class="max-h-[42vh] overflow-auto rounded border">
		          <table class="w-full table-fixed text-left text-sm">
		            <thead class="sticky top-0 bg-gray-50 text-gray-700">
		              <tr>
		                <th class="w-1/4 px-3 py-2 font-medium">{{ t('view.rg_normify_debug_field') }}</th>
		                <th class="w-[37.5%] px-3 py-2 font-medium">{{ t('view.rg_normify_debug_old') }}</th>
		                <th class="w-[37.5%] px-3 py-2 font-medium">{{ t('view.rg_normify_debug_new') }}</th>
		              </tr>
		            </thead>
		            <tbody>
		              <tr v-for="row in normifyDebugRows()" :key="row.field" class="border-t align-top">
		                <td class="break-words px-3 py-2 font-medium text-gray-800">{{ row.field }}</td>
		                <td class="whitespace-pre-wrap break-words px-3 py-2 text-gray-700">{{ formatNormifyDebugValue(row.old) }}</td>
		                <td class="whitespace-pre-wrap break-words px-3 py-2 text-gray-700">{{ formatNormifyDebugValue(row.new) }}</td>
		              </tr>
		            </tbody>
		          </table>
		        </div>

		        <p v-else class="rounded border border-dashed p-4 text-sm text-gray-700">
		          {{ t('view.rg_normify_debug_empty') }}
		        </p>

		        <div class="space-y-2 rounded border bg-gray-50 p-3">
		          <div class="flex flex-wrap items-center justify-between gap-2">
		            <h3 class="text-sm font-medium text-gray-800">
		              {{ t('view.rg_normify_debug_json_title') }}
		            </h3>
		            <Button variant="outline" size="sm" @click="normifyDebugJsonOpen = !normifyDebugJsonOpen">
		              {{ normifyDebugJsonOpen ? t('view.rg_normify_debug_hide_json') : t('view.rg_normify_debug_show_json') }}
		            </Button>
		          </div>
		          <pre v-if="normifyDebugJsonOpen" class="max-h-[38vh] overflow-auto rounded border bg-white p-3 text-xs text-gray-800">{{ formatNormifyApiJson() }}</pre>
		        </div>
		      </div>

		      <DialogFooter>
		        <Button variant="outline" @click="normifyDebugDialogOpen = false">
		          {{ t('view.close') }}
		        </Button>
		      </DialogFooter>
		    </DialogContent>
		  </Dialog>

		  <Dialog v-model:open="duplicateCustomerOpen">
		    <DialogContent class="sm:max-w-md">
		      <DialogHeader>
		        <DialogTitle>{{ t('view.customer_duplicate_title') }}</DialogTitle>
		        <DialogDescription>
		          {{ t('view.customer_duplicate_description') }}
		        </DialogDescription>
		      </DialogHeader>

		      <div v-if="duplicateCustomerStatus === 'idle' || duplicateCustomerStatus === 'failed'" class="space-y-3">
		        <div class="space-y-2">
		          <Label for="duplicate_customer_name">{{ t('view.customer_duplicate_name') }}</Label>
		          <Input
		            id="duplicate_customer_name"
		            v-model="duplicateCustomerName"
		            :disabled="duplicateCustomerStatus === 'queued' || duplicateCustomerStatus === 'running'"
		            autocomplete="off"
		          />
		        </div>
		        <p v-if="duplicateCustomerMessage" class="text-sm text-red-600">{{ duplicateCustomerMessage }}</p>
		      </div>

		      <div v-else-if="duplicateCustomerStatus === 'queued' || duplicateCustomerStatus === 'running'" class="flex items-center gap-3 py-4 text-sm">
		        <Loader2 class="w-5 h-5 animate-spin" />
		        <span>{{ duplicateCustomerMessage || t('view.customer_duplicate_started') }}</span>
		      </div>

		      <div v-else-if="duplicateCustomerStatus === 'succeeded'" class="space-y-2 py-2 text-sm">
		        <p>{{ duplicateCustomerMessage || t('view.customer_duplicate_done') }}</p>
		        <p v-if="duplicateCustomerTargetId">{{ t('view.customer_duplicate_new_id') }} {{ duplicateCustomerTargetId }}</p>
		      </div>

		      <DialogFooter>
		        <Button
		          variant="outline"
		          :disabled="duplicateCustomerStatus === 'queued' || duplicateCustomerStatus === 'running'"
		          @click="duplicateCustomerOpen = false"
		        >
		          {{ t('view.close') }}
		        </Button>
		        <Button
		          v-if="duplicateCustomerStatus === 'idle' || duplicateCustomerStatus === 'failed'"
		          class="greenbutton text-white"
		          :disabled="!duplicateCustomerName.trim()"
		          @click="submitDuplicateCustomer"
		        >
		          <Copy class="w-4 h-4 mr-2" />
		          {{ t('view.customer_duplicate_submit') }}
		        </Button>
		      </DialogFooter>
		    </DialogContent>
		  </Dialog>

		  <LogsView v-if="viewStore.actionView === 'registry.logs' && !isLoading" />
	      <DataTable v-if="viewStore.actionView === 'registry.users' && !isLoading"
				   	label="view.users"
					labelSingular="view.user"
                    :logo="rkIconUrl" endpoint="users"
				  	:columns="specsInfo['users']"
					:enableEdit="enableEditRegistryTables || userInfo?.is_accountmanager"
					:enableDetail="false">
			<template #logo><UsersRound /></template>
		    <template #extraactions="{row}">
			    <Button :title="t('view.btn_sendpasswd')" size="sm" variant="outline" @click="() => sendpasswd(row)">
				    <SendHorizontal />
			    </Button>
			    <Button v-if="userInfo?.can_impersonate_users && row.active !== false && row.id !== userInfo?.id"
			            :title="t('view.btn_impersonate_user')"
			            size="sm"
			            variant="outline"
			            @click="() => loginAsUser(row)">
				    <CircleUserRound />
			    </Button>
		    </template>
		  </DataTable>
		  <RolesRights v-if="viewStore.actionView === 'registry.roles' && !isLoading"/>
          <DataTable v-if="viewStore.actionView === 'registry.standorts' && !isLoading"
				    label="view.standorts"
					labelSingular="view.standort"
                    :logo="rkIconUrl" endpoint="standorts"
					:columns="specsInfo['standorts']"
					@swapcol="swapcol"
					:enableEdit="enableEditRegistryTables"
					:enableDetail="false">
			<template #logo><MapPin /></template>
		  </DataTable>
		  <DataTable v-if="viewStore.actionView === 'registry.functions' && !isLoading"
				    label="view.functions"
					labelSingular="view.function"
					:logo="rkIconUrl" endpoint="functions"
					:columns="specsInfo['functions']"
					@swapcol="swapcol"
					@data-mutated="onDataMutated"
					:enableEdit="enableEditRegistryTables || userInfo?.is_accountmanager"
					:enableDetail="false">
			<template #logo><Pyramid /></template>
		  </DataTable>
		  <DataTable v-if="viewStore.actionView === 'registry.imports' && !isLoading"
				    label="view.imports"  :logo="rkIconUrl" endpoint="imports"
					:columns="specsInfo['imports']"
					@swapcol="swapcol"
					:enableEdit="enableEditRegistryTables">
			<template #logo><Import /></template>					
		  </DataTable>
		  
		  <!-- Gefahrstoffe list + detail sheet layout -->
		  <GefahrstoffDetailSheet
		    :key="viewStore.refreshKey"
		    v-if="viewStore.actionView === 'registry.gefahrstoffe' && !isLoading"
		  />
		  
		  <!-- Gefahrstoffe form views (new/edit) -->
		  <GefahrstoffForm 
			v-if="(viewStore.actionView === 'registry.gefahrstoffe.new' || viewStore.actionView?.startsWith('registry.gefahrstoffe.edit.')) && !isLoading"
			:id="viewStore.actionView?.startsWith('registry.gefahrstoffe.edit.') ? parseInt(viewStore.actionView.split('.').pop()) : undefined"
		  />

		  <GefahrstoffBatchUpdate
			v-if="viewStore.actionView === 'registry.gefahrstoffe.batch' && !isLoading"
		  />

		</div>
    </SidebarInset>
  </SidebarProvider>
</template>

<style>
.bg-black\/80 {
  background-color: transparent !important;
}
</style>
